import {UseFormReturn} from 'react-hook-form';

import {DepositFormBinding} from '@dms/settings/shared';

import {FormType} from '../types/ServiceOrderVariant';

export const getDepositFormBinding = (
  formApi: UseFormReturn<FormType>
): DepositFormBinding<FormType> => ({
  allowDepositFieldName: 'deposit.allowDeposit',
  getFieldName: (field) => `deposit.${field}`,
  setFieldValue: (field, value, options) => formApi.setValue(`deposit.${field}`, value, options),
  setMethodAllowed: (method, isAllowed, options) =>
    formApi.setValue(`deposit.${method}.isAllowed`, isAllowed, options),
});
